import { render, staticRenderFns } from "./UnitCreatorAbbreviation.vue?vue&type=template&id=f8f58d3c&"
import script from "./UnitCreatorAbbreviation.vue?vue&type=script&lang=ts&"
export * from "./UnitCreatorAbbreviation.vue?vue&type=script&lang=ts&"
import style0 from "./UnitCreatorAbbreviation.vue?vue&type=style&index=0&id=f8f58d3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports